export default __webpack_public_path__ + "static/media/3.b6b0f4ec.jpg";